import { createAction } from '@reduxjs/toolkit';
import { TFilterRequest } from 'components/rest/Filter/FilterContent';

export type TLayoutItem = {
  rootPath: string;
  customPath: string;
  pathId?: string | number;
  title: string;
  showColumns?: string[];
  filters?: TFilterRequest[];
  isDefault?: boolean;
  q?: string;
  label?: React.ReactNode;
  fieldSearch?: string;
};

export type TDefaultShow = {
  rootPath: string;
  showColumns?: string[];
  pathname?: string;
};
export type TDefaultFilters = {
  rootPath: string;
  filters?: TFilterRequest[];
};

export const addLayout = createAction<TLayoutItem>('layout/add');
export const updateLayout = createAction<TLayoutItem>('layout/update');
export const delLayout = createAction<TLayoutItem>('layout/del');
export const setDefaultShow = createAction<TDefaultShow>(
  'layout/setDefaultShow',
);
export const setDefaultFilters = createAction<TDefaultFilters>(
  'layout/setDefaultFilters',
);
